import { ThemeActions } from '../constants/theme';

export const selectTheme = state => state.common[ThemeActions.Theme];